import { createContext } from "react";
import type { VideoTypes } from "@bloomberg/media-ui-av";

export interface VideoPlayerContext {
    autoplay?: boolean;
    env?: VideoTypes.PlayerEnvironments;
    foundationLayout?: boolean;
    loadSuggestions?: boolean;
    options?: Partial<VideoTypes.CombinedPlaylistPlayerOptions>;
    preloadThreshold?: number;
    repeat?: boolean;
    startFrom?: number;
    startMuted?: boolean;
    controls?: boolean;
    usePhoenixTheme?: boolean;
}

export const DEFAULT_VISIBILITY_THRESHOLD = 0.5;
const VIDEO_ENV = process.env.NEXT_PUBLIC_VIDEO_ENV;

const parseVideoEnv = (): VideoTypes.PlayerEnvironments => {
    let env;
    switch (VIDEO_ENV) {
        case "local":
            env = "local";
            break;
        case "staging":
            env = "staging";
            break;
        default:
            env = "production";
    }
    return env as VideoTypes.PlayerEnvironments;
};

// control bar that is the same for both live and vod
const FOUNDATION_PLAYER_CONTROLS = {
    controlBar: {
        children: [
            "playToggle",
            "currentTimeDisplay",
            "timeDivider",
            "durationDisplay",
            "progressControl",
            "bloombergLiveDisplay",
            "remainingTimeDisplay",
            "customControlSpacer",
            "playbackRateMenuButton",
            "captionsButton",
            {
                name: "volumePanel",
                inline: false,
            },
            "shareButton",
            "fullscreenToggle",
        ],
    },
};

export const DEFAULT_CONTEXT_OPTIONS: VideoPlayerContext = {
    startMuted: true,
    env: parseVideoEnv(),
    options: {
        use_title_bar: false,
        usePhoenixTheme: true,
        autoplay: false,
        controls: true,
        module_ad_player: "disabled",
        use_google_tag_manager: true,
        video_autoplay_on_page: true,
        ...FOUNDATION_PLAYER_CONTROLS,
    },
};

export const VideoPlayerContext = createContext<VideoPlayerContext>(
    DEFAULT_CONTEXT_OPTIONS
);
